import { Space } from 'antd';
import { useLanguage } from '../../utils/LanguageContext';
import translations from './AccountSettings.lang.json';
import { EditableValues } from '../common/CommonComponents.js';
import TrustedContactForm from '../TrustedContactForm.js';
import TrustedContactView from '../TrustedContactView.js';

const ManageTrustedContact = () => {
  const { lang } = useLanguage(translations);

  return (
    <Space direction="vertical">
      <EditableValues
        editButtonLabel={lang('editTrustedContact')}
        viewComponent={TrustedContactView}
        editComponent={TrustedContactForm}
      />
    </Space>
  );
};

export default ManageTrustedContact;
